import Screenshots from './Screenshots'

export default Screenshots
